import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Modal, Grid } from '../../canvasComponents/index';
import { useNavigate } from 'react-router-dom';
import assistLogo from '../../img/global/somethingElseProperty.svg';
// scss
import '../../css/components/PopUps/PopUps.scss';
// messages
import messages from './messages';
import useLeavingPageHandler from '../../hooks/useLeavingPageHandler';

function SomethingElsePropertyPopUp(props) {
  const { closePropertyLossCauseSomethingElse, open } = props;
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const navigate = useNavigate();

  useLeavingPageHandler();
  useEffect(() => {
    if (isButtonClicked) {
      closePropertyLossCauseSomethingElse();
      navigate('/dashboard');
    }
  }, [isButtonClicked]);

  return (
    <Modal
      ariaHideApp={false}
      id="propertySomethingElseModal"
      isOpen={open}
      onRequestClose={() => closePropertyLossCauseSomethingElse()}
    >
      <Grid>
        <Grid.Row>
          <div className="pop-up-title">
            <FormattedMessage {...messages.title} />
          </div>
        </Grid.Row>
        <Grid.Row>
          <div className="image-container">
            <img
              className="pop-up-img"
              src={assistLogo}
              alt="Assist Logo"
            />
          </div>
        </Grid.Row>
        <Grid.Row>
          <div className="pop-up-text-bigger margin-text-bottom">
            <FormattedMessage {...messages.requireText} />
            <br />
            <FormattedMessage {...messages.callUs} />
            <a className="phone-link" href="tel:1-844-766-6384"> 1-844-766-6384</a>
            <FormattedMessage {...messages.callUsTwo} />
          </div>
        </Grid.Row>
        <Grid.Row justifyContentCenter flex>
          <Button
            primary
            className="pop-up-btn"
            onClick={() => setIsButtonClicked((currValue) => !currValue)}
          >
            <FormattedMessage {...messages.close} />
          </Button>
        </Grid.Row>
      </Grid>
    </Modal>
  );
}

export default injectIntl(SomethingElsePropertyPopUp);
